// extracted by mini-css-extract-plugin
export default {"card":"card__IR9V8M6p","inputContainer":"inputContainer__e5QK9eyp","footer":"footer__rPFiur6O"};